<template>
	<div class="main-page">
		<div v-for="item in roleList" :key="item.title" class="role">
			<span>{{ item.title }}</span>
			<van-grid :column-num="3">
				<template v-if="item.children.length">
					<van-grid-item v-for="child in item.children" :key="child.name" :icon="child.icon" :text="child.name" :to="child.path" icon-prefix="icon" />
				</template>
			</van-grid>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			roleList: [
				{
					title: '订单管理',
					children: [{ name: '售课', path: '/order/createOrder', icon: 'mobile' }, { name: '订单', path: '/order/orderList', icon: 'notebook' }]
				},
				{
					title: '客户管理',
					children: [
						{ name: '客户', path: '/customer/customerList', icon: 'user' },
						{ name: '公海', path: '/customer/pool', icon: 'ship' },
						{ name: '跟进记录', path: '/track', icon: 'edit' },
						{ name: '客户查询', path: '/customer/search', icon: 'discover' }
					]
				},
				{
					title: '业绩管理',
					children: [
						{ name: '业绩', path: '/achievement/achievementlist', icon: 'data-line' },
						{ name: '收益', path: '/income/incomeList', icon: 'money' },
						{ name: '钱包', path: '/wallet/index', icon: 'wallet' }
					]
				},
				{
					title: '财务管理',
					children: [{ name: '售课', path: '/order/createOrder', icon: 'mobile' }, { name: '订单审核', path: '/audit/auditList', icon: 'coordinate' }]
				}
			]
		};
	},
	beforeRouteEnter(to, from, next) {
		console.log(to);
		const { query } = to;
		let redirect = query && query.redirect;
		if (from.name === null) {
			if (Object.keys(query).length > 1) {
				let params = '';
				for (const k in query) {
					params += k !== 'redirect' ? `&${k}=${query[k]}` : '';
				}
				params = params.replace('&', '?');
				redirect += params;
				next(redirect);
			}
		}
		next();
	}
};
</script>

<style lang="less" scoped>
.main-page {
	width: 100%;
	height: 100%;
	margin-bottom: 20px;
	overflow: auto;
	background-color: #fff;
	.role {
		span {
			line-height: 50px;
			padding-left: 20px;
			font-size: 14px;
		}
	}
	.van-grid {
		min-height: 90px;
		&::before {
			content: '';
			position: absolute;
			border: 0 solid #ebedf0;
			border-bottom-width: 1px;
			bottom: -50%;
			top: -50%;
			left: -50%;
			right: -50%;
			transform: scale(0.5);
		}
		/deep/ .icon {
			font-size: 28px;
		}
	}
}
</style>
